const properties={
  advancePayment: {
    amount:'amount',
    comments:'comments',
    companyId:'companyId',
    currencyId:'currencyId',
    document:'document',
    documentDate:'documentDate',
    documentNumber:"documentNumber",
    documentTypeId:'documentTypeId',
    exchangeRate:'exchangeRate',
    insurances:'insurances',
    otherSupports:'otherSupports',
    otherSupportsFiles:'otherSupportsFiles',
    supplierCUIT:'supplierCUIT',
    supplierInfo:'supplierInfo',
    supplierEmail:'supplierEmail',
    purchaseOrderNumber: 'purchaseOrderNumber'
  },
  creditNote: {
    amount:'amount',
    comments:'comments',
    companyId:'companyId',
    currencyId:'currencyId',
    document:'document',
    documentDate:'documentDate',
    documentNumber:"documentNumber",
    documentTypeId:'documentTypeId',
    exchangeRate:'exchangeRate',
    otherSupports:'otherSupports',
    otherSupportsFiles:'otherSupportsFiles',
    reasonId:'reasonId',
    relatedInvoice:'relatedInvoice',
    supplierCUIT:'supplierCUIT',
    supplierInfo:'supplierInfo',
    supplierEmail:'supplierEmail',
    purchaseOrderNumber: 'purchaseOrderNumber'
  },
  debitNote: {
    amount:'amount',
    comments:'comments',
    companyId:'companyId',
    currencyId:'currencyId',
    document:'document',
    documentDate:'documentDate',
    documentNumber:"documentNumber",
    documentTypeId:'documentTypeId',
    exchangeRate:'exchangeRate',
    supplierCUIT:'supplierCUIT',
    supplierInfo:'supplierInfo',
    supplierEmail:'supplierEmail',
    purchaseOrderNumber: 'purchaseOrderNumber'
  }
};

const initialValues = [
  {
    [properties.advancePayment.amount]: '',
    [properties.advancePayment.comments]: '',
    [properties.advancePayment.companyId]: 0,
    [properties.advancePayment.currencyId]: 0,
    [properties.advancePayment.document]: '',
    [properties.advancePayment.documentDate]: null,
    [properties.advancePayment.documentNumber]: '',
    [properties.advancePayment.documentTypeId]: 2,
    [properties.advancePayment.exchangeRate]: '',
    [properties.advancePayment.insurances]: '',
    [properties.advancePayment.otherSupports]: '',
    [properties.advancePayment.otherSupportsFiles]: '',
    [properties.advancePayment.supplierCUIT]: '',
    [properties.advancePayment.supplierInfo]: {},
    [properties.advancePayment.supplierEmail]: '',
    [properties.advancePayment.purchaseOrderNumber]: '',
  },
  {
    [properties.debitNote.amount]: '',
    [properties.debitNote.comments]: '',
    [properties.debitNote.companyId]: 0,
    [properties.debitNote.currencyId]: 0,
    [properties.debitNote.document]: '',
    [properties.debitNote.documentDate]: null,
    [properties.debitNote.documentNumber]: '',
    [properties.debitNote.documentTypeId]: 4,
    [properties.debitNote.exchangeRate]: '',
    [properties.debitNote.supplierCUIT]: '',
    [properties.debitNote.supplierInfo]: {},
    [properties.debitNote.supplierEmail]: '',
    [properties.debitNote.purchaseOrderNumber]: '',
  },
  {
    [properties.creditNote.amount]: '',
    [properties.creditNote.comments]: '',
    [properties.creditNote.companyId]: 0,
    [properties.creditNote.currencyId]: 0,
    [properties.creditNote.document]: '',
    [properties.creditNote.documentDate]: null,
    [properties.creditNote.documentNumber]: '',
    [properties.creditNote.documentTypeId]: 5,
    [properties.creditNote.exchangeRate]: '',
    [properties.creditNote.otherSupports]: '',
    [properties.creditNote.otherSupportsFiles]: '',
    [properties.creditNote.reasonId]: 0,
    [properties.creditNote.relatedInvoice]: '',
    [properties.creditNote.supplierCUIT]: '',
    [properties.creditNote.supplierInfo]: {},
    [properties.creditNote.supplierEmail]: '',
    [properties.creditNote.purchaseOrderNumber]: '',
  },
  {
    [properties.creditNote.amount]: '',
    [properties.creditNote.comments]: '',
    [properties.creditNote.companyId]: 0,
    [properties.creditNote.currencyId]: 0,
    [properties.creditNote.document]: '',
    [properties.creditNote.documentDate]: null,
    [properties.creditNote.documentNumber]: '',
    [properties.creditNote.documentTypeId]: 8,
    [properties.creditNote.exchangeRate]: '',
    [properties.creditNote.otherSupports]: '',
    [properties.creditNote.otherSupportsFiles]: '',
    [properties.creditNote.reasonId]: 0,
    [properties.creditNote.relatedInvoice]: '',
    [properties.creditNote.supplierCUIT]: '',
    [properties.creditNote.supplierInfo]: {},
    [properties.creditNote.supplierEmail]: '',
    [properties.creditNote.purchaseOrderNumber]: '',
  },
  {
    [properties.creditNote.amount]: '',
    [properties.creditNote.comments]: '',
    [properties.creditNote.companyId]: 0,
    [properties.creditNote.currencyId]: 0,
    [properties.creditNote.document]: '',
    [properties.creditNote.documentDate]: null,
    [properties.creditNote.documentNumber]: '',
    [properties.creditNote.documentTypeId]: 1, 
    [properties.creditNote.exchangeRate]: '',
    [properties.creditNote.otherSupports]: '',
    [properties.creditNote.otherSupportsFiles]: '',
    [properties.creditNote.reasonId]: 0,
    [properties.creditNote.relatedInvoice]: '',
    [properties.creditNote.supplierCUIT]: '',
    [properties.creditNote.supplierInfo]: {},
    [properties.creditNote.supplierEmail]: '',
    [properties.creditNote.purchaseOrderNumber]: '',
  },
  {
    [properties.creditNote.amount]: '',
    [properties.creditNote.comments]: '',
    [properties.creditNote.companyId]: 0,
    [properties.creditNote.currencyId]: 0,
    [properties.creditNote.document]: '',
    [properties.creditNote.documentDate]: null,
    [properties.creditNote.documentNumber]: '',
    [properties.creditNote.documentTypeId]: 3, 
    [properties.creditNote.exchangeRate]: '',
    [properties.creditNote.otherSupports]: '',
    [properties.creditNote.otherSupportsFiles]: '',
    [properties.creditNote.reasonId]: 0,
    [properties.creditNote.relatedInvoice]: '',
    [properties.creditNote.supplierCUIT]: '',
    [properties.creditNote.supplierInfo]: {},
    [properties.creditNote.supplierEmail]: '',
    [properties.creditNote.purchaseOrderNumber]: '',
  }
]

export const GetInitialValuesToDocument = (documentTypeId) => {
  return initialValues.find(x => x.documentTypeId === documentTypeId);
}